module.exports = __webpack_public_path__ + "static/pozitivniZpravy-20d44240fa43b52e68081e202614c8fa.png";